/**
 * Voice catalog — mirrors lambda/api/voices.py ALLOWED_VOICES.
 * Keep in sync: backend validates PATCH /user/voice against its own whitelist.
 */

export const DEFAULT_VOICE_ID = 'QEi4zxVOMw89fR5oFDAG';

export const VOICES = [
  {
    id: 'QEi4zxVOMw89fR5oFDAG',
    name: 'Seasoned Mentor',
    description: 'Old-school, experienced. The default.',
  },
  {
    id: 'NdriLenbaaaFc8niBNDQ',
    name: 'English Butler',
    description: 'Polished, dignified, measured.',
  },
  {
    id: '9JqF6OmJtGjHTDODKG2c',
    name: 'Midwestern Coach',
    description: 'Warm, encouraging, steady.',
  },
  {
    id: '03vEurziQfq3V8WZhQvn',
    name: 'No-Nonsense Coach',
    description: 'Direct, high-intensity.',
  },
];

export const SAMPLE_PHRASE = "Hi, I'm your Navigator. Ready when you are.";

export function isKnownVoice(voiceId) {
  return VOICES.some((v) => v.id === voiceId);
}
